module.exports = __webpack_public_path__ + "img/bell.e596853f.svg";